import {isEmpty as _isEmpty} from 'lodash';
import React from 'react';

import Chip from '@ui/Chip';

export const ShowWarnings = ({ warnings }) => {
    return (_isEmpty(warnings))
        ? ''
        : warnings.map((warning) => (
            <Chip key={warning} size='small' color='error' label={warning} />
        ));
};
